import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ExceptionManagementCenter",
  "use": "icon-ExceptionManagementCenter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ExceptionManagementCenter\">\n  <path d=\"M11.1 4.9 3.7 18a1.8 1.8 0 0 0 1.6 2.7h14.8a1.8 1.8 0 0 0 1.6-2.7L13.3 4.9a1.8 1.8 0 0 0-3.2 0Z\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linejoin=\"round\" />\n  <path d=\"M12 9v5M12 17.2v.1\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol